<template>
  <aside class="aside">
    <!-- START Sidebar (left)-->
    <div class="aside-inner">
      <nav data-sidebar-anyclick-close class="sidebar">
        <!-- START sidebar nav-->
        <ul class="nav">
          <!-- START user info-->
          <li class="has-user-block">
            <div id="user-block" class="collapse in">
              <div class="item user-block">
                <!-- User picture-->
                <div class="user-block-picture">
                  <div class="user-block-status">
                    <img
                      src="../assets/img/user/img-profile-default-admin.svg"
                      alt="Avatar"
                      width="60"
                      height="60"
                      class="img-thumbnail img-circle"
                    />
                  </div>
                </div>
                <!-- Name and Job-->
                <div class="user-block-info">
                  <span class="user-block-name">{{ user.firstName }} {{ user.lastName }}</span>
                  <span class="user-block-role">IR Admin</span>
                </div>
              </div>
            </div>
          </li>
          <!-- END user info-->
          <!-- Iterates over all sidebar items-->
          <li :class="{ active: $route.name === 'Users' }">
            <router-link :to="{ name: 'Users' }" title="all users" replace>
              <em class="icon-people"></em>
              <span data-localize="sidebar.nav.ACCOUNT">All Users</span>
            </router-link>
          </li>
          <li :class="{ active: $route.name === 'FailedTransactionList' }">
            <router-link :to="{ name: 'FailedTransactionList'}" title="trasactions" replace>
              <em class="icon-dislike"></em>
              <span data-localize="sidebar.nav.WIDGETS">Cancelled/Failed Transactions</span>
            </router-link>
          </li>
          <li>
            <a @click="downloadImpactPreferencesReport">
              <em class="fa fa-download"></em>
              <span>Export Impact Preferences Report</span>
            </a>
          </li>
          <li>
            <a @click="downloadMonthlyMaturitiesReport">
              <em class="fa fa-download"></em>
              <span>Export Monthly Maturities Report</span>
            </a>
          </li>
          <li>
            <a @click="downloadDocumentViewsReport">
              <em class="fa fa-download"></em>
              <span>Export Document Views Report</span>
            </a>
          </li>
          <li>
            <a @click="downloadFeedbackReport">
              <em class="fa fa-download"></em>
              <span>Export Feedback Report</span>
            </a>
          </li>
          <li :class="{ active: $route.name === 'AdminSettings' }">
            <router-link :to="{ name: 'AdminSettings'}" title="settings" replace>
              <em class="fa fa-gear"></em>
              <span data-localize="sidebar.nav.WIDGETS">Settings</span>
            </router-link>
          </li>
        </ul>
        <!-- END sidebar nav-->
      </nav>
    </div>
    <!-- END Sidebar (left)-->
  </aside>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'irAdminSideBar',
  data() {
    return {
      userProfile: {
        fullName: '',
        accountType: '',
      },
    };
  },
  methods: {
    ...mapActions('impactPreferences', ['exportImpactPreferencesReport']),
    ...mapActions('documentViews', ['exportDocumentViewsReport']),
    ...mapActions('monthlyMaturities', ['exportMonthlyMaturitiesReport']),
    ...mapActions('feedback', ['exportFeedbackReport']),
    async downloadImpactPreferencesReport() {
      await this.exportImpactPreferencesReport();
    },
    async downloadMonthlyMaturitiesReport() {
      await this.exportMonthlyMaturitiesReport();
    },
    async downloadDocumentViewsReport() {
      await this.exportDocumentViewsReport();
    },
    async downloadFeedbackReport() {
      await this.exportFeedbackReport();
    },
  },
  computed: {
    ...mapState('app', ['user']),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.aside,
.aside-inner,
.sidebar,
.nav,
.wrapper > .aside .aside-inner {
  width: 240px;
  overflow: auto;
}
.sidebar > .nav > li > a {
  white-space: normal;
}
.sidebar > .nav > li > a em {
  position: absolute;
  top: 14px;
}
.sidebar > .nav > li > a span {
  margin-left: 30px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// IRAdminSideBar.vue?81541112